import { gql } from "lib/apolloClient";

export const subjectStandardFragment = gql`
  fragment subjectStandardFragment on PlannerElementNodeSetConnection {
    edges {
      node {
        id
        title
        isArchived
        subject {
          id
          name
          isArchived
        }
        plannerElementNodeSetWrapperV2 {
          ... on PlannerElementNodeSetWrapper {
            publishedData {
              edges {
                node {
                  id
                }
              }
            }
          }
          ... on PlannerBenchmarkSetWrapper {
            publishedData {
              edges {
                node {
                  id
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const standardSetFragment = gql`
  fragment standardSetFragment on PlannerElementNodeSet {
    id
    title
    isArchived
    subject {
      id
      name
      isArchived
    }
  }
`;
